import gameApi from '../../../api/game';

const SET_GAME_RANKING = 'SET_GAME_RANKING';

const state = {
  game: {
    ranking: []
  }
};

const getters = {
  getGameRanking: state => {
    return state.game.ranking;
  }
};

const mutations = {
  [SET_GAME_RANKING] (state, xugarHeroStatus) {
    state.game.ranking = xugarHeroStatus;
  }
};

const actions = {
  retrieveGameRanking ({ commit }, { context }) {
    gameApi.getGameRanking(context).then(data => {
      commit(SET_GAME_RANKING, data);
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/brand/xugarhero/store/modules/game/index.js